export class Point {
    constructor(public x = 0, public y = 0) {
    }
}
